export const theme: {
  location_name: string
} = {
  location_name: "Master"
}